module.exports = __webpack_public_path__ + "img/wbqlogo.c3068e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/web/wbqlogo.png
// module id = ocfc
// module chunks = 2 3 6 8 15 16 18 19 20 21 22 25 37